export const CHECK_USER_CONSENT = 'CHECK_USER_CONSENT'
export const CHECK_USER_CONSENT_SUCCESS = 'CHECK_USER_CONSTENT_SUCCESS'
export const CHECK_USER_CONSENT_FAILURE = 'CHECK_USER_CONSTENT_FAILURE'
export const USER_CONSENT_ACCEPT = 'USER_CONSENT_ACCEPT'
export const USER_CONSENT_ACCEPT_SUCCESS = 'USER_CONSENT_ACCEPT_SUCCESS'
export const UPDATE_MOUTHSHUT_EVENT = 'UPDATE_MOUTHSHUT_EVENT'
